import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { handleCopy } from "../Utils/CopyDocID";
import "./AdmAriane.css";

const AdmAriane = ({
  modelName = [],
  onChangeConfigKey,
  onModelFilterChange,
  mode = "default",
  ModelName = "",
  instanceName = "",
  instanceId = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState("{}");
  const configkeyset = Cookies.get("configkey");
  const clientId = Cookies.get("clientId");
  const modelIdHome = Cookies.get("modelIdHome");
  const selectedElement = clientId != undefined ? clientId : modelIdHome;

  // Initialise le modèle sélectionné depuis les cookies si disponible.
  useEffect(() => {
    const savedId = Cookies.get("modelId");
    if (
      savedId &&
      savedId !== "all" &&
      modelName.length > 0 &&
      configkeyset !== "DefaultLots"
    ) {
      const model = modelName.find(
        (m) => m.id.toString() === savedId && m.component,
      );
      if (model) {
        const selectedValue = JSON.stringify({
          id: model.id,
          component: model.component,
          name: model.name,
        });
        setSelectedModel(selectedValue);
      }
    } else {
      setSelectedModel("{}");
    }
  }, [modelName, configkeyset]);

  // Change le modèle sélectionné et filtre le tableau
  const handleModelChange = (event) => {
    const selectedValue = JSON.parse(event.target.value);
    setSelectedModel(event.target.value);

    if (selectedValue.id) {
      Cookies.set("modelId", selectedValue.id);

      // Appel le callback pour filtrer le tableau
      if (onModelFilterChange) {
        onModelFilterChange(selectedValue.id);
      }

      if (onChangeConfigKey && selectedValue.component) {
        const capitalizedComponent =
          selectedValue.component.charAt(0).toUpperCase() +
          selectedValue.component.slice(1);

        const targetRoute = `/Admin/${capitalizedComponent}Lots`;

        onChangeConfigKey(selectedValue.component);
        navigate(targetRoute);
        Cookies.set("configkey", `${capitalizedComponent}Lots`);
      }
    } else {
      Cookies.set("modelId", "");

      // Réinitialise le filtre
      if (onModelFilterChange) {
        onModelFilterChange("");
      }

      if (onChangeConfigKey) {
        onChangeConfigKey("Default");
        navigate(`/Admin/DefaultLots`);
      }
    }
  };

  if (mode === "detailed") {
    return (
      <div className="ariane-container">
        <Link to="/Admin" className="ariane-link">
          {t("Home")}
        </Link>
        <p className="ariane-separator">{" > "}</p>
        <Link to={`/Admin/AdmLotsTable`} className="ariane-link">
          {t("AllModels")}
        </Link>
        <p className="ariane-separator">{" > "}</p>

        <p className="ariane-text">{ModelName}</p>
        <p className="ariane-separator">{" > "}</p>
        <span className="ariane-text">{instanceName}</span>
        <CopyToClipboard
          text={instanceId}
          onCopy={() => handleCopy(instanceId)}
        >
          <button
            className="btn btn-sm "
            data-toggle="tooltip"
            title={t("Copy instanceId")}
          >
            <FontAwesomeIcon icon={faCopy} className="fa-copy" />
          </button>
        </CopyToClipboard>
        <p className="ariane-separator">{" > "}</p>
        <p className="ariane-text">Documents</p>
      </div>
    );
  }

  return (
    <div className="ariane-container">
      {/* Accueil */}
      <Link to="/Admin" className="ariane-link">
        {t("Home")}
      </Link>
      <p className="ariane-separator">{" > "}</p>

      {clientId ? (
        // Mode client : Accueil > [client] > Instances > [choisir model]
        <>
          <p className="ariane-text">{clientId}</p>
          <p className="ariane-separator">{" > "}</p>
          <span className="ariane-text">Instances</span>
          <p className="ariane-separator">{" > "}</p>
          <select
            className="form-select ariane-select"
            id="modelSelect"
            onChange={handleModelChange}
            value={selectedModel}
          >
            <option value="{}">{t("AllModels") || "Tous les modèles"}</option>
            {modelName &&
              modelName.length > 0 &&
              modelName.map((model) => (
                <option
                  key={model.id}
                  value={JSON.stringify({
                    id: model.id,
                    component: model.component,
                    name: model.name,
                  })}
                >
                  {model.name}
                </option>
              ))}
          </select>
        </>
      ) : (
        // Mode model (page d'accueil) : Accueil > [choisir model] > Instances
        <>
          <p className="ariane-text">{selectedElement}</p>
          <p className="ariane-separator">{" > "}</p>
          <span className="ariane-text">Instances</span>
        </>
      )}
    </div>
  );
};

export default AdmAriane;
